import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import AnimeDetailPage from "../pages/anime/page";
import AboutPage from "../pages/about/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/anime/:id",
    element: <AnimeDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;